angular.module('backstage.controllers.misc', ['ngSanitize'])
    .controller('SmartTablePagesAndItemsSettingsCtrl', require('./SmartTablePagesAndItemsSettingsCtrl'))
    .controller('SpotletIframeContainerCtrl', require('./SpotletIframeContainerCtrl'))
    .controller('VueWrapperCtrl', require('./VueWrapperCtrl'))
    .controller('VueMainMenu', require('./VueMainMenu'))
    .controller('BtMetadataFilterController', require('./BtMetadataFilterController'));
